module.exports = __webpack_public_path__ + "static/BambooHR-e5d385e4b241b6f934a7585701aa3805.jpg";